import { useState, useEffect } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import {
  getRefreshToken,
  getAccessToken,
  getUserInfo,
  logoutUser,
} from "../store/login";

const useAuthenticateTokens = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.login.isLoggedIn);
  const accessExpiration = useSelector((state) => state.login.accessExpiration);
  const refreshExpiration = useSelector(
    (state) => state.login.refreshExpiration
  );
  const refreshToken = useSelector((state) => state.login.accessToken);
  const accessToken = useSelector((state) => state.login.accessToken);
  const accessLoading = useSelector((state) => state.login.accessLoading);
  const refreshLoading = useSelector((state) => state.login.refreshLoading);

  useEffect(() => {
    const dateOfNow = new Date();
    const timestampOfNow = dateOfNow.getTime();

    if (isLoggedIn === "true" && refreshToken && accessToken) {
      if (timestampOfNow > refreshExpiration) {
        dispatch(logoutUser());
      }
      if (
        timestampOfNow > accessExpiration &&
        timestampOfNow < refreshExpiration
      ) {
        dispatch(getAccessToken());
      }
    } else {
      dispatch(logoutUser());
    }
  }, [
    isLoggedIn,
    accessExpiration,
    refreshExpiration,
    accessToken,
    accessLoading,
    refreshLoading,
  ]);
};

export default useAuthenticateTokens;
